import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'top-post-placeholder',
  templateUrl: './top-post-placeholder.component.html',
  styleUrls: ['./top-post-placeholder.component.scss']
})
export class TopPostPlaceholderComponent implements OnInit {

  public topPostFakes = [1, 2, 3, 4, 5, 6];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/main/post-overview/same-influencer-top-five-posts/top-post-placeholder/top-post-placeholder.component.ts